module.exports = __webpack_public_path__ + "img/logo.9cec4213.png";